export const resultsMessages = {
    end: 'Do you really want to leave this page? this data will be lost',
    notEnd: 'Your result is loading, do you really want to leave this page?'
}

export const helpMessages = {
    title: "How to format your search string?",
    rules: [
        ['All terms should be wrapped in quotes, e.g.: "Apple Sauce"', []],
        ['Valid operators: OR and AND', []],
        ["Precedence: first AND expressions, then OR expressions", []],
        ['Don\'t forget the spaces between your expressions', [
                'Wrong: ("Apple"OR"Apple Souce")AND"Mashed Potatoes"',
                'Right: ("Apple" OR "Apple Souce") AND "Mashed Potatoes"'
            ] 
        ],
        ['Parentheses inside parentheses are not supported', [
                'e.g.: (("Apple" OR "Pie") AND "Apple Souce") OR "Honey"'
            ]
        ],
        ['Instead, you can use:', [
                '("Apple" OR "Pie") AND "Apple Souce" OR "Honey"'
            ]
        ],
        ['Using a wrong syntax may cause errors or wrong results.', []],
    ]
}

export const aboutMessages = {
    title: "About",
    content: [
        `The Grey Scraper was created to help researches finding grey 
        literature in the agile software development context.`,
        `You can use a research string and filters to find relevant literature. 
        You will be able to download the results in xlsx and csv format.`
    ]
}

export const resultInfoMessages = {
    title: "Results",
    content: [
        `You can download the results once they are loaded, it may take a few minutes.`
    ]
}